import { getStaticPathsForPage } from '@cinch-nx/landing-feature-car-reviews-hub'

export const getStaticPaths = getStaticPathsForPage()

export {
  V2GetStaticProps as getStaticProps,
  CarReviewsHubFeature as default,
} from '@cinch-nx/landing-feature-car-reviews-hub'
